import * as React from "react";

import { EMPTY_ARRAY } from "@/react/empty";
import Debug from "@/react/debug";
import { KEY } from "@/react/components/table/useTableMutations";

/**
 * Custom hook which returns a callback which can be used to set a
 * column-wide value for the given columnId in the given instance
 * of TAP TanStack Table.
 *
 * @param table
 * @param columnId
 * @return {(function(*): void)|*}
 */
const useColumnWideSet = (table, columnId) => {
  const allRows = table?.getRowModel?.()?.rows ?? EMPTY_ARRAY;
  const schema = table?.options?.meta?.schema;
  const updateRows = table?.options?.meta?.updateRows;

  return React.useCallback(
    (columnValue) => {
      Debug.log(
        `[useColumnWideSet] Calling for ${columnId} with value=`,
        columnValue
      );

      const allKeys = allRows.map((row) => row.original[KEY]);
      if (updateRows && allKeys?.length > 0 && schema) {
        updateRows(allKeys, new Map([[columnId, columnValue]]), schema);
      } else {
        Debug.warn(
          "[useColumnWideSet] Could not execute as some parameters are empty or undefined.",
          { updateRows, allKeys, schema }
        );
      }
    },
    [table, columnId, schema, updateRows, allRows]
  );
};

export default useColumnWideSet;
